import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { ShareOptions } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import translate from "@insite/client-framework/Translate";
// import { CartLineCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels"; // Poolcorp Custom Code
import MyListsDetailsPageTypeLink from "@insite/content-library/Components/MyListsDetailsPageTypeLink";
// import WishListSharingStatus, {
//     WishListSharingStatusStyles,
// } from "@insite/content-library/Components/WishListSharingStatus"; // Poolcorp Custom Code
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; // Poolcorp Custom Code
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
// import GridItem, { GridItemProps } from "@insite/mobius/GridItem"; // Poolcorp Custom Code
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import Icon, { IconPresentationProps } from "@insite/mobius/Icon"; // Poolcorp Custom Code
import Star from "@insite/mobius/Icons/Star";
import StarX from "@insite/mobius/Icons/StarX";
import Tag from "@insite/mobius/Icons/Tag";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
// import Typography, { TypographyProps } from "@insite/mobius/Typography"; // Poolcorp Custom Code
import React, { useContext } from "react";
import { connect, HandleThunkActionCreator } from "react-redux";
import { css } from "styled-components";

/* Poolcorp custom code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { CartLineCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import Icon, { IconPresentationProps, IconProps, IconWrapper } from "@insite/mobius/Icon";
import { markForFocusLater } from "@insite/mobius/Overlay/helpers/focusManager";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ShopCart from "@store/Components/Icons/ShopCart";
import { useCurrentLanguage } from "@store/Hooks/Context";
import GridItem, { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import { TwoButtonModalStyles } from "@store/Overrides/Components/TwoButtonModal";
import WishListSharingStatus, { WishListSharingStatusStyles } from "@store/Overrides/Components/WishListSharingStatus";
import { dispatchAddToCartEventCartLine } from "@store/Services/AnalyticsService";
import { productImageStyles } from "@store/theme/common/mixins";
import { productTableProps } from "@store/theme/common/props/productTable";
/* PoolCorp Custom Code */
import { tableGridProps } from "@store/theme/common/props/tableGrid";
import { TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import Color from "color";
/* Poolcorp Custom code */

const mapStateToProps = (state: ApplicationState) => ({
    language: state.context.session.language,
    allowEditingOfWishLists: getSettingsCollection(state).wishListSettings.allowEditingOfWishLists,
    isUpdatingCart: state.context.isUpdatingCart,
    /* PoolCorp Custom Code */
    checkoutReviewAndSubmitUrl: getPageLinkByPageType(state, "CheckoutReviewAndSubmitPage")?.url,
    /* PoolCorp Custom Code */
});

interface OwnProps {
    wishList: WishListModel;
    extendedStyles?: WishListCardStyles;
    addWishListToCart: HandleThunkActionCreator<typeof addWishListToCart>;
    deleteWishList?: () => void;
    leaveWishList?: () => void;
    toggleFavorite?: () => void;
    toggleHide?: () => void;
}

type Props = ReturnType<typeof mapStateToProps> &
    OwnProps &
    /* PoolCorp Custom Code */
    HasHistory;
/* PoolCorp Custom Code */

export interface WishListCardStyles {
    gridContainer?: GridContainerProps;
    wishListInfoGridItem?: GridItemProps;
    wishListInfoGridContainer?: GridContainerProps;
    basicInfoGridItem?: GridItemProps;
    basicInfoGridContainer?: GridContainerProps;
    detailLinkGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyProps;
    lastUpdatedGridItem?: GridItemProps;
    lastUpdatedText?: TypographyProps;
    extendedInfoGridItem?: GridItemProps;
    extendedInfoGridContainer?: GridContainerProps;
    productImagesGridItem?: GridItemProps;
    productImageLink?: LinkPresentationProps;
    productImage?: LazyImageProps;
    sharingStatusGridItem?: GridItemProps;
    sharingStatus?: WishListSharingStatusStyles;
    actionGridItem?: GridItemProps;
    actionGridMediumHidden?: HiddenProps;
    actionOverflowIcon?: IconPresentationProps;
    overflowMenu?: OverflowMenuPresentationProps;
    actionAddToCartClickable?: ClickablePresentationProps;
    actionHideClickable?: ClickablePresentationProps;
    actionDeleteClickable?: ClickablePresentationProps;
    actionLeaveClickable?: ClickablePresentationProps;
    actionAddToCartButton?: ButtonPresentationProps;
    actionHideLink?: LinkPresentationProps;
    actionDeleteButton?: ButtonPresentationProps;
    actionLeaveButton?: ButtonPresentationProps;
    actionFavoriteClickable?: ClickablePresentationProps;
    basicIconGridContainer?: GridContainerProps;
    detailIconGridItem?: GridItemProps;
    starIcon?: IconPresentationProps;
    starXIcon?: IconPresentationProps;
    tagTooltip?: TooltipPresentationProps;
    // Poolcorp custom code
    tableCellActions?: DataTableCellProps;
    tableCellActionsWrapper?: InjectableCss;
    tableCellProducts?: InjectableCss;
    tableCellProductsWrapper?: InjectableCss;
    addButton?: ButtonProps;
    trashIcon?: IconProps;
    linkWrappingImage?: InjectableCss;
    tableCellTitle?: DataTableCellProps;
    obsoleteListItemsModal?: TwoButtonModalStyles;
    tableGridHead?: GridContainerProps;
    tableGridCellText?: TypographyPresentationProps;
    descriptionTableGridCellText?: TypographyPresentationProps;
    tableGridRow?: GridItemProps;
    tableGridRowContainer?: GridContainerProps;
    titleTableGridCell?: GridItemProps;
    descriptionTableGridCell?: GridItemProps;
    lastUpdatedTableGridCell?: GridItemProps;
    statusTableGridCell?: GridItemProps;
    actionsTableGridCell?: GridItemProps;
    mobileDescriptionTableGridCell?: GridItemProps;
    mobileHeaderHidden?: HiddenProps;
    mobileHeader?: TypographyPresentationProps;
    mobileLastUpdatedHeader?: InjectableCss;
    mobileDescriptionHeader?: InjectableCss;
    mobileStatusHeader?: InjectableCss;
    mobileActionsTableHeader?: InjectableCss;
    mobileLastUpdatedTableGridCell?: GridItemProps;
    mobileStatusTableGridCell?: GridItemProps;
    mobileActionsTableGridCell?: GridItemProps;
    AddToCartIcon?: ButtonPresentationProps;
    mobileActionDeleteClickable?: InjectableCss;
    mobileActionAddToCartClickable?: InjectableCss;
}

export const wishListCardStyles: WishListCardStyles = {
    /* Poolcorp custom code - Start */
    tableGridRow: {
        ...tableGridProps.tableGridRow,
        css: css`
            ${tableGridProps.tableGridRow?.css}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: [null, null, "0"], properties: ["border-bottom"] }],
                    mediaOptions.max,
                )}
            }
        `,
    },
    tableGridRowContainer: {
        ...tableGridProps.tableGridRowContainer,
        css: css`
            ${tableGridProps.tableGridRowContainer?.css}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        {
                            values: [
                                null,
                                null,
                                `1px solid ${Color(props.theme.colors.common.disabled).lighten(0.4).hex()}`,
                            ],
                            properties: ["border"],
                        },
                        { values: [null, null, "10px 5px"], properties: ["padding"] },
                        { values: [null, null, "2em"], properties: ["border-radius"] },
                    ],
                    mediaOptions.max,
                )}
            
                ${GridOffset} {
                align-items: center;
            }
        `,
    },
    mobileHeaderHidden: tableGridProps.mobileHeaderHidden,
    mobileHeader: tableGridProps.mobileHeader,
    titleTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [6, 6, 6, 3, 3],
        css: css`
            ${tableGridProps.tableGridCell?.css}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        { values: [null, null, TYPOGRAPHY.weight.black], properties: ["font-weight"] },
                        { values: [null, null, TYPOGRAPHY.size.large], properties: ["font-size"] },
                    ],
                    mediaOptions.max,
                )}
        `,
    },
    mobileActionsTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [6, 6, 6, 0, 0],
        css: css`
            ${tableGridProps.tableGridCell?.css}
            justify-content: flex-end;
        `,
    },
    descriptionTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [0, 0, 0, 3, 3],
    },
    descriptionTableGridCellText: {
        ellipsis: true,
    },
    mobileDescriptionTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [7, 7, 7, 0, 0],
        css: css`
            ${tableGridProps.tableGridCell?.css}
            display: block;
        `,
    },
    lastUpdatedTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [0, 0, 0, 1.75, 1.75],
    },
    mobileLastUpdatedTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [12, 12, 12, 0, 0],
        css: css`
            ${tableGridProps.tableGridCell?.css}
            display: block;
            ${props => {
                return css`
                    color: ${Color(props.theme.colors.common.disabled).darken(0.25).hex()};
                `;
            }}
        `,
    },
    actionsTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [0, 0, 0, 1.5, 1.25],
        css: css`
            ${tableGridProps.tableGridCell?.css}
            justify-content: flex-end;
        `,
    },
    statusTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [0, 0, 0, 2.75, 3],
    },
    mobileStatusTableGridCell: {
        ...tableGridProps.tableGridCell,
        width: [5, 5, 5, 0, 0],
        css: css`
            ${tableGridProps.tableGridCell?.css}
            display: block;
            text-align: right;
            > span,
            button {
                float: right;
                text-align: right;
            }
        `,
    },
    mobileLastUpdatedHeader: {
        ...tableGridProps.mobileHeader,
        css: css`
            ${tableGridProps.mobileHeader?.css}
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    mobileDescriptionHeader: {
        ...tableGridProps.mobileHeader,
        css: css`
            ${tableGridProps.mobileHeader?.css}
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    mobileStatusHeader: {
        ...tableGridProps.mobileHeader,
        css: css`
            ${tableGridProps.mobileHeader?.css}
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    /* Poolcorp custom code - End */
    gridContainer: {
        gap: 5,
    },
    wishListInfoGridItem: {
        width: [10, 10, 8, 10, 10],
        align: "middle",
    },
    basicInfoGridItem: { width: [12, 12, 5, 4, 4] },
    basicInfoGridContainer: {
        gap: 10,
    },
    detailLinkGridItem: { width: 12 },
    descriptionGridItem: { width: 12 },
    descriptionText: { ellipsis: true },
    lastUpdatedGridItem: { width: 12 },
    extendedInfoGridItem: {
        width: [12, 12, 7, 8, 8],
        align: "middle",
    },
    productImageLink: {
        css: css`
            ${productImageStyles()}
            width: 65px;
        `,
    },
    productImagesGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            flex-wrap: wrap;
        `,
    },
    productImage: {
        css: css`
            max-width: 75px;
            img {
                height: 100%;
            }
        `,
        errorTypographyProps: {
            size: 11,
            css: css`
                max-height: 65px;
            `,
        },
    },
    sharingStatusGridItem: { width: [12, 12, 12, 4, 4] },
    sharingStatus: {
        privateTooltip: {
            cssOverrides: {
                tooltipWrapper: css`
                    margin-left: 0.25em;
                `,
            },
        },
        statusText: {
            css: css`
                display: flex;
                align-items: center;
            `,
        },
    },
    actionAddToCartButton: {
        icon: {
            position: "right",
            src: ShopCart,
        },
        css: css`
            padding: 5px 10px;
            > ${TypographyStyle} {
                width: 0px;
            }
            > ${IconWrapper} {
                margin-left: 0px;
                height: 22px;
                width: 22px;

                > svg {
                    height: 22px;
                    width: 22px;
                }
            }
        `,
    },
    actionDeleteButton: {
        color: "danger",
        css: css`
            ${({ theme }) => theme?.button?.defaultProps?.css}
            margin-left: 5px;
            min-width: 0;
            padding: 0 5px;
        `,
    },
    tableCellActions: productTableProps.tableCellControls,
    tableCellActionsWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    tableCellProductsWrapper: {
        css: css`
            display: flex;
        `,
    },
    trashIcon: {
        src: "Trash2",
    },
    mobileActionDeleteClickable: {
        css: css`
            position: relative;
            color: ${getColor("danger.main")};
            span {
                color: ${getColor("danger.main")};
                position: absolute;
                text-align: right;
                top: -10%;
                right: 0;
            }

            svg {
                position: relative;
                right: -5%;
                top: 2.5px;
                height: 20px;
            }

            :disabled {
                color: ${getColor("text.disabled")};
                span {
                    color: ${getColor("text.disabled")};
                }
            }
        `,
    },
    mobileActionAddToCartClickable: {
        css: css`
            position: relative;
            button {
                position: absolute;
                top: -10%;
                right: 0;
                display: block;
                width: 100%;
                max-width: 100%;
                min-height: 37px;
            }
        `,
    },
    AddToCartIcon: {
        icon: {
            position: "right",
            src: ShopCart,
        },
        css: css`
            min-height: 32px;
            max-height: 32px;
            padding-left: 0;
            padding-right: 0;
            background: transparent;
            border: transparent;

            > ${IconWrapper} {
                color: ${getColor("text.main")};
                float: right;
                height: 20px;
                width: 32px;
                position: relative;
                right: -4%;

                > svg {
                    height: 22px;
                    width: 22px;
                    position: absolute;
                    top: 0;
                    right: -8%;
                }
            }
        `,
    },
    linkWrappingImage: {
        css: css`
            position: relative;
            margin-right: 5px;
        `,
    },
};

const WishListCard = ({
    language,
    allowEditingOfWishLists,
    isUpdatingCart,
    extendedStyles,
    wishList,
    addWishListToCart,
    deleteWishList,
    leaveWishList,
    toggleFavorite,
    toggleHide,
    /* PoolCorp Custom Code */
    history,
    checkoutReviewAndSubmitUrl,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const isLoadingAnyList = useAppSelector(state => Object.keys(state.data.wishLists.isLoading).length > 0);

    /* Poolcorp Custom Code */
    const currentLanguage = useCurrentLanguage();
    /* Poolcorp Custom Code */

    const clickAddToCartHandler = (e: any) => {
        e.preventDefault();

        addWishListToCart({
            apiParameter: { wishListId: wishList.id },
            onSuccess: onAddAllToCartSuccess,
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult);
                }
            },
        });
    };
    /* PoolCorp Custom Code */
    const checkoutNowClickHandler = () => {
        if (checkoutReviewAndSubmitUrl) {
            history.push(checkoutReviewAndSubmitUrl);
        }
    };
    /* PoolCorp Custom Code */

    const onAddAllToCartSuccess = (result: CartLineCollectionModel) => {
        /* Poolcorp Custom Code */
        result?.cartLines?.forEach(cartLine => {
            dispatchAddToCartEventCartLine(currentLanguage, cartLine);
        });
        /* Poolcorp Custom Code */

        toasterContext.addToast({
            body: result.notAllAddedToCart
                ? siteMessage("Lists_Items_Not_All_Added_To_Cart")
                : siteMessage("SelectedList_AddedToCart"),
            messageType: "success",
            cssOverrides: {
                toast: css`
                    width: ${result.notAllAddedToCart ? "600px" : "500px"};
                `,
            },
            timeoutLength: 6000,
            actionButtonConfig: {
                text: translate("Checkout Now"),
                onClick: checkoutNowClickHandler,
                props: {
                    variant: "tertiary",
                    sizeVariant: "small",
                    hoverMode: "lighten",
                },
            },
        });
    };

    const updatedOnDisplay = getLocalizedDateTime({
        dateTime: new Date(wishList.updatedOn),
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    let lastUpdatedDisplay = `${translate("Updated")} ${updatedOnDisplay}`;
    if (wishList.updatedByDisplayName && !wishList.isAutogenerated) {
        lastUpdatedDisplay += ` ${translate("by")} ${wishList.updatedByDisplayName}`;
    }

    const canAddToCart = wishList.canAddToCart && wishList.hasAnyLines; // Poolcorp Custom Code
    const addToCartLabel = translate("Add"); // Poolcorp Custom Code
    const toggleHideButtonText = wishList.isHidden ? translate("Unhide List") : translate("Hide List");
    const deleteLabel = translate("Delete");
    const leaveLabel = translate("Leave List");
    const [styles] = React.useState(() => mergeToNew(wishListCardStyles, extendedStyles));

    return (
        /* Poolcorp Custom Code - Start */
        <GridItem {...styles.tableGridRow} key={wishList.id}>
            <GridContainer {...styles.tableGridRowContainer}>
                <GridItem {...styles.titleTableGridCell}>
                    <MyListsDetailsPageTypeLink
                        title={wishList.name}
                        wishListId={wishList.id}
                        testSelector="wishListCardName"
                    />
                </GridItem>
                <GridItem {...styles.mobileActionsTableGridCell}>
                    <OverflowMenu position="end" onOpen={markForFocusLater} {...styles.overflowMenu}>
                        <Clickable
                            {...styles.mobileActionAddToCartClickable}
                            onClick={clickAddToCartHandler}
                            disabled={!canAddToCart || isUpdatingCart}
                        >
                            {translate("Add List to Cart")}
                            <Button {...styles.AddToCartIcon} />
                        </Clickable>
                        <Clickable
                            {...styles.mobileActionDeleteClickable}
                            onClick={deleteWishList}
                            disabled={
                                !(
                                    allowEditingOfWishLists &&
                                    !!deleteWishList &&
                                    !wishList.isSharedList &&
                                    !wishList.isAutogenerated
                                )
                            }
                        >
                            {translate("Delete")}
                            <Icon {...styles.trashIcon} />
                        </Clickable>
                    </OverflowMenu>
                </GridItem>
                <GridItem {...styles.descriptionTableGridCell}>
                    <Typography {...styles.descriptionTableGridCellText} data-test-selector="wishListCardDescription">
                        {wishList?.description ?? ""}
                    </Typography>
                </GridItem>
                <GridItem {...styles.lastUpdatedTableGridCell}>
                    <Typography {...styles.tableGridCellText} data-test-selector="wishListCardLastUpdated">
                        {updatedOnDisplay}
                    </Typography>
                </GridItem>
                <GridItem {...styles.mobileLastUpdatedTableGridCell}>
                    <Hidden {...styles.mobileHeaderHidden}>
                        <Typography {...styles.mobileLastUpdatedHeader}>{`${translate("Last Updated")}: `}</Typography>
                    </Hidden>
                    <Typography {...styles.tableGridCellText} data-test-selector="wishListCardLastUpdated">
                        {updatedOnDisplay}
                    </Typography>
                </GridItem>
                <GridItem {...styles.mobileDescriptionTableGridCell}>
                    <Hidden {...styles.mobileHeaderHidden}>
                        <Typography {...styles.mobileDescriptionHeader}>{`${translate("Description")}: `}</Typography>
                    </Hidden>
                    <Typography {...styles.tableGridCellText} data-test-selector="wishListCardDescription">
                        {wishList?.description ?? ""}
                    </Typography>
                </GridItem>
                <GridItem {...styles.statusTableGridCell}>
                    <WishListSharingStatus removeTooltip extendedStyles={styles.sharingStatus} wishList={wishList} />
                </GridItem>
                <GridItem {...styles.mobileStatusTableGridCell}>
                    <Hidden {...styles.mobileHeaderHidden}>
                        <Typography {...styles.mobileStatusHeader}>{`${translate("Status")}: `}</Typography>
                    </Hidden>
                    <WishListSharingStatus removeTooltip extendedStyles={styles.sharingStatus} wishList={wishList} />
                </GridItem>
                <GridItem {...styles.actionsTableGridCell}>
                    <StyledWrapper {...styles.tableCellActionsWrapper}>
                        <Button
                            {...styles.actionAddToCartButton}
                            disabled={!canAddToCart || isUpdatingCart}
                            data-test-selector={`wishListAddToCartButton_${wishList.id}`}
                            onClick={clickAddToCartHandler}
                        />
                        <Button
                            {...styles.actionDeleteButton}
                            onClick={deleteWishList}
                            data-test-selector={`wishListCardDeleteButton_${wishList.id}`}
                            disabled={
                                !(
                                    allowEditingOfWishLists &&
                                    !!deleteWishList &&
                                    !wishList.isSharedList &&
                                    !wishList.isAutogenerated
                                )
                            }
                        >
                            <Icon {...styles.trashIcon} />
                        </Button>
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </GridItem>
        /* Poolcorp Custom Code - End */
    );
};

export default withHistory(connect(mapStateToProps)(WishListCard));
